import {
	AVAILABLE_AI_FEATURES,
	type AvailableAiFeature,
} from "@foodlista/shared/ai/types"
import { LOCALE_KEYS } from "@foodlista/shared/i18n/constants"
import { i18nSchema, strictI18nSchema } from "@foodlista/shared/i18n/schemas"
import { z } from "zod"

export const internalOriginPathSchema = z
	.string()
	.min(1)
	.max(500)
	.regex(/^\/(?!\/)/)
	.refine((path) => !/[\\\s]/.test(path))

export const textGenerateInputSchema = z.object({
	text: i18nSchema,
	maxLength: z.number().optional(),
	locale: z.enum(LOCALE_KEYS).optional(),
	feature: z.enum(AVAILABLE_AI_FEATURES),
	/**
	 * Stable client-side field and action identity. It lets a
	 * reopened UI rehydrate its own run without confusing sibling fields.
	 */
	scopeKey: z.string().min(1).max(300),
	/**
	 * Unlocalized app path the generation was requested from. Unread by the run:
	 * it rides in the payload so the BOC row can offer a way back to the field,
	 * which no other input identifies. Callers working on an unsaved draft leave
	 * it out — there is nothing to go back to.
	 */
	originPath: internalOriginPathSchema.optional(),
})

export const textGenerateOutputSchema = strictI18nSchema

export type TextGenerateInput = z.infer<typeof textGenerateInputSchema>
export type TextGenerateOutput = z.infer<typeof textGenerateOutputSchema>
export type TextGenerateProgressPhase =
	| { kind: "generating" }
	| { kind: "done" }

export type TextGenerateFeature = AvailableAiFeature
